import api from "../Axios.js";

const createCustomField = (data) => {
  try {
    return api.post("/custom-field/admin/create-update-custom-field", data);
  } catch (error) {
    console.error("Error creating custom field:", error);
    throw error;
  }
};

const updateCustomField = (id, data) => {
  try {
    return api.post(`/custom-field/admin/create-update-custom-field`, {...data, id});
  } catch (error) {
    console.error("Error updating custom field:", error);
    throw error;
  }
};

const getCustomFields = async (params) => {
  try {
    return await api.get(`/custom-field/admin/get-custom-field-by-module?module=${params}`);
  } catch (error) {
    console.error("Error fetching custom fields:", error);
    throw error;
  }
};

const getCustomFieldsList = async (data) => {
  try {
    return await api.post(`/custom-field/admin/get-custom-field-list`, data);
  } catch (error) {
    console.error("Error fetching custom fields:", error);
    throw error;
  }
};

const deleteCustomField = (id) => {
  try {
    return api.delete(`/custom-field/admin/delete-custom-field-by-id/${id}`);
  } catch (error) {
    console.error("Error deleting custom field:", error);
    throw error;
  }
};

export { createCustomField, updateCustomField, getCustomFields, getCustomFieldsList, deleteCustomField };
